import { IonIcon } from '@ionic/react'
import React from 'react'
import { checkmarkSharp } from 'ionicons/icons'
import './ScoreButton.component.css'

export interface IScoreButton {
  label: string
  score: string | number | null
  isRed?: boolean
  showCheckMark?: boolean
  onClickAction: () => void
  disabled?: boolean
}

const ScoreButton: React.FC<IScoreButton> = (props: IScoreButton) => {
  const { label, score = 0, isRed = false, showCheckMark = false, onClickAction, disabled = false } = props
  return (
    <div
      className={`score-button ${disabled ? 'disabled' : ''}`}
      onClick={() => {
        if (disabled) return
        onClickAction()
      }}>
      {score != null && <div className='score-box'>{score}</div>}
      <div className={`${isRed ? 'score-text red' : 'score-text'}`} dangerouslySetInnerHTML={{ __html: label }} />
      {showCheckMark && <IonIcon size='small' color='success' className='item-check-icon' icon={checkmarkSharp} />}
    </div>
  )
}

export default ScoreButton
